module.exports = __webpack_public_path__ + "assets/img/block-left-hover-fdff520a.png";